<!--  -->
<template>
  <div>
    <div class="footerBox">
      <div class="scrollImg">
        <van-swipe class="my-swipe" :autoplay="3000" :show-indicators="false">
          <van-swipe-item v-for="(item, index) in certificate" :key="index">
            <div class="twoImgBox">
              <img :src="item.src1" alt />
              <span>{{ item.name1 }}</span>
            </div>
            <div class="blockBox"></div>
            <div class="twoImgBox">
              <img :src="item.src2" alt />
              <span>{{ item.name2 }}</span>
            </div>
            <div class="blockBox"></div>
            <div class="twoImgBox">
              <img :src="item.src3" alt />
              <span>{{ item.name3 }}</span>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="footerTips">
        客服热线：
        <span style="font-size: 1.5rem;" @click="callPhone">4006-352-107</span>
      </div>
      <div class="footerTips">法定工作日（09:00~18:00）</div>
      <!-- <div class="footerTips">商务合作邮箱：marketing@gminsz.com</div> -->
      <div class="footerImgBox">
        <!-- <div class="img">
          <a href="https://credit.szfw.org/CX202003101225885571130380.html">
            <img src="http://icon.szfw.org/sf.png" alt />
          </a>
        </div>
        <div class="img" id="footerImgOne"></div> -->
      </div>

      <!-- <div class="footerTips">深圳市宝安区宝安互联网产业基地C区A栋407</div> -->
      <!-- <div class="footerTips">©copyright 深圳市金矿网络科技有限公司2017-2019</div> -->
      <div class="footerTips">
        <a href="https://beian.miit.gov.cn/" target="_blank">网站备案号：粤ICP备18111848号-1</a>
      </div>
      <div class="footerTips">
        <a href="https://beian.miit.gov.cn/" target="_blank">APP备案号：粤ICP备18111848号-7A</a>
      </div>
    </div>

    <!-- 回到顶部 -->
    <div class="backTop" v-show="btnFlag" @click="backtop">TOP</div>
    <!-- 联系客服 -->
    <div class="customer" v-show="btnFlag" @click="showCustomer">
      <img src="../../assets/kefu_1.png" alt />
    </div>
    <div class="customerTxt" v-show="btnFlag" @click="showCustomer">在线客服</div>
    <div style="display:none;" id="statistics"></div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      certificate: [
        {
          src1: require("../../assets/wenwangwen.png"),
          name1: "文网文",
          src2: require("../../assets/yaopinzigezheng.jpg"),
          name2: "互联网医药",
          src3: require("../../assets/dianxin.jpg"),
          name3: "ICP"
        },
        {
          src1: require("../../assets/duiwaimaoyi.jpg"),
          name1: "进出口贸易",
          src2: require("../../assets/shipinzigezheng.jpg"),
          name2: "食品安全",
          src3: require("../../assets/guanbo.jpg"),
          name3: "广播电视"
        },
        {
          src1: require("../../assets/guanbo.jpg"),
          name1: "广播电视",
          src2: require("../../assets/yiliao.jpg"),
          name2: "医疗器械",
          src3: require("../../assets/wenwangwen.png"),
          name3: "文网文"
        }
      ],
      btnFlag: false
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    showCustomer() {
      _MEIQIA("showPanel");
    },
    callPhone() {
      window.location.href = "tel://4006-352-107";
    },
    backtop() {
      var timer = setInterval(function () {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
    // 显示回到顶部按钮
    showbtn() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 60) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    window.addEventListener("scroll", this.showbtn, true);
    // 统计
    // let dom = document.getElementById("statistics");
    // let scriptTips = document.createElement("script");
    // scriptTips.type = "text/javascript";
    // scriptTips.src =
    //   "https://s9.cnzz.com/z_stat.php?id=1278972811&web_id=1278972811";
    // dom.appendChild(scriptTips);
    // let ele = document.getElementById("footerImgOne");
    // let script = document.createElement("script");
    // script.type = "text/javascript";
    // script.id = "kXScript";
    // script.src =
    //   "https://kxlogo.knet.cn/seallogo.dll?sn=e19122444030080507cngl000000&h=47";
    // ele.appendChild(script);
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.backTop {
  position: fixed;
  bottom: 5rem;
  background: rgba(140, 137, 137, 0.5);
  color: #fff;
  right: 1.5rem;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  font-size: 0.5rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  z-index: 9;
}

.customer {
  position: fixed;
  bottom: 1.5rem;
  background: #3caff3;
  color: #fff;
  right: 1.5rem;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  font-size: 0.5rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  z-index: 9;
}

.customerTxt {
  position: fixed;
  bottom: 0.5rem;
  color: #3caff3;
  right: 1.5rem;
  width: 3rem;
  border-radius: 50%;
  font-size: 0.5rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  z-index: 9;
  text-align: center;
}

.customer img {
  width: 80%;
  height: 80%;
}

img {
  width: 100%;
  height: 100%;
}

.footerBox {
  background: #000;
  color: #c3c3c3;
  margin-top: 3rem;
  padding: 0.5rem 1.5rem 1.5rem 1.5rem;
  font-size: 0.8rem;
  text-align: center;
}

.footerTips {
  margin-top: 1rem;
}

.footerTips a {
  color: #c3c3c3;
}

.footerImgBox {
  display: flex;
  align-items: center;
  justify-content: center;
}

.footerImgBox .img {
  // background: red;
  border-radius: 10px;
  height: 47px;
  margin-top: 1rem;
  overflow: hidden;
  width: 8rem;
}

#footerImgOne {
  margin-left: 0.5rem;
}

#footerImgOne>>>img {
  width: 100% !important;
  height: 100% !important;
}

.scrollImg {
  // height: 8rem;
}

.my-swipe {
  height: 7.5rem;
  width: 60%;
  margin: auto;
  margin-top: 1rem;
}

.twoImgBox {
  height: 5rem;
  width: 6rem;
  float: left;
}

.van-swipe-item {
  display: flex;
}

.blockBox {
  width: 10%;
}

.twoImgBox span {
  font-size: 0.5rem;
}

.twoImgBox img {
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/mobile/common/footer.vue